import React, { useEffect, useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  // Phone number placeholder - swap with real number in production
  const phoneNumber = '(949) 555-0117';
  const phoneLink = 'tel:9495550117';
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'Results',
    href: '#results'
  }, {
    name: 'Process',
    href: '#process'
  }, {
    name: 'Insights',
    href: '#insights'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-138">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-139">
        <div className="flex justify-between items-center" data-id="element-140">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-141">
            <a href="#" className="font-bold text-xl tracking-tight text-slate-900 flex items-center gap-2" data-id="element-142">
              <div className="w-8 h-8 bg-brand-600 rounded-lg flex items-center justify-center" data-id="element-143">
                <span className="text-white font-bold text-lg leading-none" data-id="element-144">
                  S
                </span>
              </div>
              SEO Company OC
            </a>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-145">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-slate-600 hover:text-brand-600 transition-colors" data-id="element-146">
                {link.name}
              </a>)}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center" data-id="element-147">
            <a href={phoneLink} className="inline-flex items-center justify-center px-5 py-2.5 border border-transparent text-sm font-semibold rounded-lg text-white bg-brand-600 hover:bg-brand-700 shadow-sm hover:shadow-md transition-all gap-2" data-id="element-148">
              <Phone className="w-4 h-4" data-id="element-149" />
              Call {phoneNumber}
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="flex items-center md:hidden gap-4" data-id="element-150">
            <a href={phoneLink} className="p-2 text-brand-600 bg-brand-50 rounded-full" aria-label="Call us" data-id="element-151">
              <Phone className="w-5 h-5" data-id="element-152" />
            </a>
            <button type="button" className="text-slate-500 hover:text-slate-900 p-1" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-153">
              <span className="sr-only" data-id="element-154">Open main menu</span>
              {mobileMenuOpen ? <X className="block h-6 w-6" aria-hidden="true" data-id="element-155" /> : <Menu className="block h-6 w-6" aria-hidden="true" data-id="element-156" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-157">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-b border-slate-100 overflow-hidden" data-id="element-158">
            <div className="px-4 pt-2 pb-6 space-y-1 shadow-lg" data-id="element-159">
              {navLinks.map(link => <a key={link.name} href={link.href} className="block px-3 py-3 rounded-md text-base font-medium text-slate-700 hover:text-brand-600 hover:bg-slate-50" onClick={() => setMobileMenuOpen(false)} data-id="element-160">
                  {link.name}
                </a>)}
              <div className="mt-4 pt-4 border-t border-slate-100" data-id="element-161">
                <a href={phoneLink} className="flex items-center justify-center w-full px-4 py-3 border border-transparent text-base font-medium rounded-lg text-white bg-brand-600 hover:bg-brand-700 gap-2" data-id="element-162">
                  <Phone className="w-5 h-5" data-id="element-163" />
                  Call {phoneNumber}
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}